import {
  LayoutDashboard,
  TrendingUp,
  ShoppingCart,
  ScrollText,
  FilePlus,
  Repeat,
  FileText,
  ReceiptIndianRupee,
  FileMinus,
  Package,
  Layers,
  FolderTree,
  BookOpen,
  Users,
  Contact,
  Globe,
  FileStack,
  LayoutTemplate,
  Sparkles,
  LayoutGrid,
  Megaphone,
  Images,
  SlidersHorizontal,
  MousePointerClick,
  Star,
  Tag,
  Menu as MenuIcon,
  Image,
  Newspaper,
  PenLine,
  FolderOpen,
  MessageSquareQuote,
  Award,
  Wallet,
  Wallet2,
  UsersRound,
  Building2,
  ClipboardCheck,
  ListTodo,
  Settings,
  Truck,
  MapPin,
  Palette,
  Paintbrush,
  PanelBottom,
  PhoneCall,
  UserCog,
  School,
  LayoutList,
  Ticket,
  Boxes,
  CreditCard,
  History,
} from "lucide-react";

/** Full staff portal navigation — filtered by RBAC permissions in SideBar. */
export const STAFF_MENU_DATA = [
  { title: "Dashboard", icon: LayoutDashboard, path: "/", type: "link", permission: "dashboard.read" },

  {
    title: "Sales",
    icon: TrendingUp,
    type: "accordion",
    groupStart: true,
    submenus: [
      { title: "Orders", icon: ShoppingCart, path: "/orders", type: "link" },
      { title: "Quotes", icon: ScrollText, path: "/quotes", type: "link" },
      { title: "New Quote", icon: FilePlus, path: "/new-quote", type: "link" },
      { title: "Auto-billing", icon: Repeat, path: "/recurring-invoices", type: "link" },
      { title: "Invoices", icon: FileText, path: "/invoice", type: "link" },
      { title: "Receipts", icon: ReceiptIndianRupee, path: "/receipt", type: "link" },
      { title: "Credit Notes", icon: FileMinus, path: "/credit-notes", type: "link" },
    ],
  },

  {
    title: "Products",
    icon: Package,
    type: "accordion",
    groupStart: true,
    submenus: [
      { title: "Products / Services", icon: Package, path: "/products", type: "link" },
      { title: "Grouped Products", icon: Boxes, path: "/grouped-product", type: "link" },
      { title: "Categories", icon: FolderTree, path: "/category", type: "link" },
      { title: "Variations", icon: Layers, path: "/features", type: "link" },
      { title: "Coupons", icon: Ticket, path: "/coupon", type: "link" },
      {
        title: "Catalog",
        icon: BookOpen,
        type: "accordion",
        submenus: [
          { title: "Catalog Categories", icon: FolderOpen, path: "/catlog-catgeory", type: "link" },
          { title: "Catalog", icon: LayoutList, path: "/catlog", type: "link" },
        ],
      },
    ],
  },

  {
    title: "Customers",
    icon: Users,
    type: "accordion",
    groupStart: true,
    submenus: [
      { title: "Customers", icon: Users, path: "/customer", type: "link" },
      { title: "CRM", icon: Contact, path: "/crm", type: "link" },
      { title: "CRM Analytics", icon: Contact, path: "/crm-analytics", type: "link" },
      { title: "WhatsApp", icon: MessageSquareQuote, path: "/crm-message", type: "link" },
    ],
  },

  {
    title: "Website / App",
    icon: Globe,
    type: "accordion",
    groupStart: true,
    submenus: [
      {
        title: "Homepage Builder",
        icon: LayoutTemplate,
        type: "accordion",
        submenus: [
          { title: "Hero Section", icon: Sparkles, path: "/herosection", type: "link" },
          { title: "Home Sections", icon: LayoutGrid, path: "/newarrival", type: "link" },
          { title: "CTA Sections", icon: Megaphone, path: "/headline", type: "link" },
          { title: "Sliders", icon: Images, path: "/slider", type: "link" },
        ],
      },
      { title: "Menus", icon: MenuIcon, path: "/menus", type: "link" },
      { title: "Media Library", icon: Image, path: "/media", type: "link" },
      { title: "Blog", icon: Newspaper, path: "/blog", type: "link" },
      { title: "Testimonials", icon: MessageSquareQuote, path: "/testimonial", type: "link" },
      { title: "Brand Assets", icon: Award, path: "/brand", type: "link" },
    ],
  },

  {
    title: "Finance",
    icon: Wallet,
    type: "accordion",
    groupStart: true,
    submenus: [
      { title: "Expenses", icon: Wallet, path: "/expense", type: "link" },
      { title: "Wallet", icon: Wallet2, path: "/wallet-target", type: "link" },
    ],
  },

  {
    title: "Team",
    icon: UsersRound,
    type: "accordion",
    groupStart: true,
    submenus: [
      { title: "Departments", icon: Building2, path: "/departments", type: "link" },
      { title: "Team Directory", icon: UsersRound, path: "/team-directory", type: "link" },
      { title: "Attendance", icon: ClipboardCheck, path: "/team-attendance", type: "link" },
      { title: "My Attendance", icon: ClipboardCheck, path: "/attendance", type: "link" },
      { title: "Tasks", icon: ListTodo, path: "/tasks", type: "link" },
    ],
  },

  {
    title: "Students",
    icon: School,
    type: "accordion",
    visibleSk: "Skates",
    groupStart: true,
    submenus: [
      { title: "Admission", icon: School, path: "/admission", type: "link" },
      { title: "Form Builder", icon: PenLine, path: "/admission-form-builder", type: "link" },
      { title: "Admission Plans", icon: Tag, path: "/admission-plans", type: "link" },
      { title: "Attendance", icon: ClipboardCheck, path: "/student-attendance", type: "link" },
      { title: "Batches", icon: LayoutGrid, path: "/admission-batches", type: "link" },
      { title: "Centers", icon: Building2, path: "/admission-centers-settings", type: "link" },
    ],
  },

  {
    title: "Marketing",
    icon: Megaphone,
    type: "accordion",
    groupStart: true,
    submenus: [
      { title: "Email Campaigns", icon: Megaphone, path: "/refer", type: "link" },
      { title: "Campaign Usage", icon: History, path: "/refer-usage", type: "link" },
    ],
  },

  {
    title: "Settings",
    icon: Settings,
    type: "accordion",
    groupStart: true,
    submenus: [
      { title: "Subscription", icon: CreditCard, path: "/plan", type: "link" },
      { title: "Delivery Settings", icon: Truck, path: "/delivery", type: "link" },
      { title: "Pincode Settings", icon: MapPin, path: "/pincode", type: "link" },
      { title: "Themes", icon: Palette, path: "/appearance/themes", type: "link" },
      { title: "Appearance", icon: Paintbrush, path: "/appearance/customize", type: "link" },
      { title: "Footer Settings", icon: PanelBottom, path: "/footer-setting", type: "link" },
      { title: "Users", icon: UserCog, path: "/user-records", type: "link" },
      { title: "Google Ads", icon: Megaphone, path: "/integrations", type: "link" },
      { title: "General Settings", icon: Settings, path: "/setting", type: "link" },
    ],
  },
];
